// extracted by mini-css-extract-plugin
export default {"page_container":"Croissance_page_container__W0bNR","tab_container":"Croissance_tab_container__aFqqL"};